import { createTheme, ThemeOptions } from '@mui/material';
import { ColorScheme } from 'shared/assets/styles/theme/color-schemes';

import { breakpoints } from './breakpoints';
import { MuiBackdrop } from './components/mui-backdrop';
import { MuiCssBaseline } from './components/mui-baseline';
import { MuiDialog } from './components/mui-dialog';
import { MuiTab, MuiTabs } from './components/mui-tabs';
import { timeFieldTheme } from './components/mui-timefield';
import { darkGradients, lightGradients } from './gradients';
import { isMobileDevice } from './is-mobile-device';
import { isTouchDevice } from './is-touch-device';
import { darkPalette, lightPalette } from './palette';
import { darkShadowBox, lightShadowBox } from './shadow-box';
import { spacing } from './spacing';
import { typographyDesktop, typographyMobile } from './typography';

const baseTheme: ThemeOptions = {
  breakpoints,
  spacing,
  typography: isMobileDevice() ? typographyMobile : typographyDesktop,
  components: {
    MuiCssBaseline,
    MuiDialog,
    MuiBackdrop,
    MuiTabs,
    MuiTab,
    ...timeFieldTheme,
  },
  isMobile: isMobileDevice(),
  isTouchDevice: isTouchDevice(),
};

export const darkTheme = createTheme({
  ...baseTheme,
  palette: darkPalette,
  shadowBox: darkShadowBox,
  gradients: darkGradients,
  colorScheme: ColorScheme.Dark,
});

export const lightTheme = createTheme({
  ...baseTheme,
  palette: lightPalette,
  shadowBox: lightShadowBox,
  gradients: lightGradients,
  colorScheme: ColorScheme.Light,
});
